import { authEntryGuard } from '@/features/auth/guards/authEntryGuard.js'
import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import AuthLayout from '@/features/auth/layout/AuthLayout.vue'
import DummyRouter from '@/features/ui/components/DummyRouter.vue'

export const authRoutes = [
  {
    path: 'auth',
    component: DummyRouter,
    children: [
      {
        path: '',
        component: AuthLayout,
        children: [
          {
            beforeEnter: [authEntryGuard],
            path: 'login',
            component: () => import('@/features/auth/views/login/AuthLoginView.vue'),
          },
          {
            path: 'forgot-password',
            component: () =>
              import('@/features/auth/views/forgotPassword/AuthForgotPasswordView.vue'),
          },
          {
            beforeEnter: [authEntryGuard],
            path: 'register',
            component: () => import('@/features/auth/views/register/AuthRegisterView.vue'),
          },
          {
            path: 'unsubscribe',
            component: () => import('@/features/auth/views/unsubscribe/UnsubscribeEmails.vue'),
          },
          {
            path: 'subscribe',
            component: () => import('@/features/auth/views/subscribe/SubscribeEmails.vue'),
          },
        ],
      },
      {
        beforeEnter: [authGuard, sessionGuard],
        path: 'club-selector',
        component: () => import('@/features/auth/views/clubSelector/AuthClubSelector.vue'),
      },
      {
        path: 'logout',
        component: () => import('@/features/auth/views/logout/AuthLogoutView.vue'),
      },
      {
        path: 'merge-accounts',
        component: () => import('@/features/auth/views/mergeAccounts/MergeAccountsView.vue'),
      },
    ],
  },
]
